import React from 'react';

function PrinterComponent() {
    return <div>PrinterComponent</div>;
}

export default PrinterComponent;
